export default "__VITE_ASSET__CLDbQ7Bt__"